<template>
<div id="app">
    <router-view />
</div>
</template>

<script>
export default {
    async mounted() {
        $(document).on("click", "[data-toggle='lightbox']", function (event) {
            event.preventDefault();
            $(this).ekkoLightbox();
        });
    }
};
</script>

<style>
@import "../src/assets/css/app.css";

body {
    padding-right: 0 !important
}
</style>
